/**
 * State used in rendering Skeleton
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
